import { apiClient } from "../api/client";
import { API_URLS } from "../api/config";
const { AgentLadger } = API_URLS;

export const listAgentsLadger = (payload) => {
  return apiClient({ url: AgentLadger.list, data: payload })
    .then((res) => res?.data===null?{}:res?.data===null?{}:res?.data===null?{}:res?.data)
    .catch((err) => {
      throw new Error(err);
    });
};

export const createAgentLadger = (payload) => {
  return apiClient({ url: AgentLadger.create, data: payload })
    .then((res) => res)
    .catch((err) => {
      throw new Error(err?.data?.message);
    });
};

export const updateAgentLadger = (payload) => {
  return apiClient({
    url: AgentLadger.update + payload.id,
    data: payload,
    method: "PUT",
  })
    .then((res) => res.data)
    .catch((err) => {
      throw new Error(err?.data?.message || "Can't update record.");
    });
};

export const softDeleteAgentLadger = (payload) => {
  return apiClient({
    url: AgentLadger.softdelete + payload.id,
    data: payload,
    method: "PUT",
  })
    .then((res) => console.log(res))
    .catch((err) => {
      throw new Error(err);
    });
};

export const deleteAgentLadger = (payload) => {
  return apiClient({
    url: AgentLadger.delete + payload.id,
    data: payload,
    method: "DELETE",
  })
    .then((res) => res)
    .catch((err) => {
      throw new Error(err);
    });
};

export const getAgentLadgerCount = () => {
  return apiClient({ url: AgentLadger.count })
    .then((res) => res.data?.totalRecords || 0)
    .catch((err) => {
      throw new Error(err);
    });
};

export const getAgentLadgerAggregate = (payload) => {
  return apiClient({ url: AgentLadger.aggregation, data: payload })
    .then((res) => res.data?.data)
    .catch((err) => {
      throw new Error(err);
    });
};

export const getAgentLadgerById = (payload) => {  
  return apiClient({
    url: AgentLadger.singlerecord + payload,
    data: { query: { isActive: true, isDeleted: false } },
    method: "GET",
  })
    .then((res) => res.data)
    .catch((err) => {
      throw new Error(err);
    });
};

export const softDeleteMultipleAgentLadger = (payload) => {
  return apiClient({
    url: AgentLadger.multisoftdelete,
    data: payload,
    method: "PUT",
  })
    .then((res) => res)
    .catch((err) => {
      throw new Error(err);
    });
};
export const suspendAgentLadger = (payload) => {
  console.log("payload.id",payload.id)
  return apiClient({
    url: AgentLadger.suspend_unSuspend,
    data: {userId:payload.id},
    method: "PUT",
  })
    .then((res) => res.data)
    .catch((err) => {
      throw new Error(err?.data?.message || "Can't suspend/unsuspend record.");
    });
};
